<template>
  <div id="app">
    <router-view/>
    <Promotion/>
  </div>
</template>

<script>
import Promotion from '@/views/dashboard/components/Promotion.vue'
export default {
  components: {
    Promotion
  },
  created () {
    this.$store.dispatch('getSystemConfigs')
    this.$store.dispatch('getLanguages')
  }
}
</script>
